import React, { useEffect, useRef } from "react"
import { useSnackbar } from "notistack"
import EditUsernameDialog from "./dialog/auth/EditUsernameDialog"
import { API_URL } from "../constants/constants"
import { useDialog } from "../context/DialogContext"
import { useAppDispatch, useAppSelector } from "../store"
import { setUserName } from "../store/userReducer"
import { updateUserName } from "../api/user"

export const UsernameRequiredGuard = () => {
  const dispatch = useAppDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [openDialog, closeDialog] = useDialog()
  const dialogOpenedRef = useRef(false)

  const user = useAppSelector((state) => state.user.user)

  useEffect(() => {
    if (!user.address || user.userName !== null || dialogOpenedRef.current) {
      return
    }

    dialogOpenedRef.current = true

    const handleSaveUsername = async (username) => {
      const data = await updateUserName(user.sessionToken, username)

      if (!data.success) {
        throw new Error(data.error || "Failed to update username")
      }

      dispatch(setUserName(data.username || username))
      closeDialog()
      dialogOpenedRef.current = false
    }

    openDialog({
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
      children: (
        <EditUsernameDialog
          disableClose
          onSave={handleSaveUsername}
          initialUsername=""
        />
      ),
    })
  }, [
    user.address,
    user.userName,
    user.sessionToken,
    dispatch,
    openDialog,
    closeDialog,
    enqueueSnackbar,
  ])

  useEffect(() => {
    if (user.userName !== null) {
      dialogOpenedRef.current = false
    }
  }, [user.userName])

  return null
}
